import SelectFormutil, { OptionItem } from 'components/Formutil/SelectFormutil';
import { GenderEnum } from 'types/customer';
import { isEmptyValue } from 'utils/helper';
import { printf } from 'utils/i18n';

export interface GenderFormutil {
    gender: GenderEnum;
}

interface GenderProps {
    disabled?: boolean;
}

const genderOptions: OptionItem[] = [
    { value: GenderEnum.MALE, label: __('Male') },
    { value: GenderEnum.FEMALE, label: __('Female') },
    { value: GenderEnum.OTHER, label: __('Other') }
];

const Gender: React.FC<GenderProps> = ({ disabled }) => {
    return (
        <SelectFormutil
            name="gender"
            label={__('Gender')}
            checker={value => {
                if (disabled) {
                    return true;
                }

                if (isEmptyValue(value)) {
                    return printf(__('Please select your %s'), __('gender'));
                }

                return true;
            }}
            selectProps={{
                options: genderOptions,
                placeholder: __('Please Select'),
                disabled
            }}
        />
    );
};

export default Gender;
